let print = {
  vm: null,
  error(msg, debug, duration = 2000, center = false) {
    const show = (debug && this.vm.debug) || !debug
    show && this.vm.$message({
      message: msg,
      type: 'error',
      duration: duration,
      showClose: true,
      customClass: center ? 'el-message_custom el-message_center' : 'el-message_custom'
    })
  },
  info(msg, debug, duration = 2000, center = false) {
    const show = (debug && this.vm.debug) || !debug
    show && this.vm.$message({
      message: msg,
      type: 'info',
      duration: duration,
      showClose: true,
      customClass: center ? 'el-message_custom el-message_center' : 'el-message_custom'
    })
  },
  success(msg, debug, duration = 2000, center = false) {
    const show = (debug && this.vm.debug) || !debug
    show && this.vm.$message({
      message: msg,
      type: 'success',
      duration: duration,
      showClose: true,
      customClass: center ? 'el-message_custom el-message_center' : 'el-message_custom'
    })
  },
  warning(msg, debug, duration = 2000, center = false) {
    const show = (debug && this.vm.debug) || !debug
    show && this.vm.$message({
      message: msg,
      type: 'warning',
      duration: duration,
      showClose: true,
      customClass: center ? 'el-message_custom el-message_center' : 'el-message_custom'
    })
  },
  tip(msg, debug, duration = 2000, close = false) {
    const show = (debug && this.vm.debug) || !debug
    show && this.vm.$message({
      message: msg,
      type: 'warning',
      duration: duration,
      showClose: close,
      customClass: 'el-message_custom el-message_tip'
    })
  },
  set(vm) {
    this.vm = vm
  }
}

export default print




// WEBPACK FOOTER //
// ./src/common/print.js